import { Box, Button, Chip, TextField } from '@mui/material';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import GlobalDialog from '../../../../components/mui/Dialogue/GlobalDialog';
import useHandleApiResponse from '../../../../Hooks/useHandleApiResponse';
import { RegularizeActionThunk } from '../../../../redux/features/leaveSlice';
import { savePaginationData } from '../../../../redux/features/globalDatagridSlice';

export default function ApproveOrRjectRegularization({ reject, data, setActionDependancy, view, paginationData }) {
  const { loading } = useSelector((state) => state.leave);
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState('');
  const dispatch = useDispatch();
  const handleApiResponse = useHandleApiResponse();

  const sureButtonHandling = () => {
    const ids = data?.map((e) => e.latestApprovalId);
    dispatch(
      RegularizeActionThunk({
        ids,
        status: reject ? 2 : 1,
        comments: reject ? reason : '',
        view: view === 'HR' ? 'hr' : view === 'Team Head' ? 'rh' : '',
      })
    ).then((res) => {
      handleApiResponse(res, {
        onSuccess: () => {
          setOpen(false);
          setReason('');
          setActionDependancy((prev) => !prev);
          dispatch(savePaginationData({ ...paginationData, checkedRowsIds: [] }));
        },
      });
    });
  };

  return (
    <GlobalDialog
      maxWidth={'sm'}
      fullWidth
      title={`Are you sure to ${reject ? 'Reject' : 'Approvel'} them ?`}
      open={open}
      setOpen={setOpen}
      popupButton={
        <>
          <Button onClick={() => setOpen(true)} variant="contained" color={`${reject ? 'error' : 'primary'}`}>
            {reject ? 'Reject' : 'Approve'}
          </Button>
        </>
      }
      content={
        <Box display={'flex'} flexDirection="column" gap={1}>
          <Box>
            {data?.map((e, i) => (
              <Chip label={`${e?.slNo} : ${e?.createdByName}`} sx={{ m: 1 }} key={i} />
            ))}
          </Box>
          {reject && (
            <TextField
              label="Reason"
              multiline
              placeholder="Enter Reason for Rejection"
              rows={2}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              fullWidth
              variant="outlined"
            />
          )}
          <Box alignSelf={'flex-end'} display="flex" gap={1}>
            <Button variant="contained" color="error" onClick={() => setOpen(false)}>
              cancel
            </Button>
            <Button variant="contained" onClick={sureButtonHandling} disabled={loading}>
              {loading ? 'Please Wait...' : 'sure'}
            </Button>
          </Box>
        </Box>
      }
    />
  );
}
